import { render, staticRenderFns } from "./CorreiosSettings.vue?vue&type=template&id=696317d2&"
import script from "./CorreiosSettings.vue?vue&type=script&lang=js&"
export * from "./CorreiosSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports